/* eslint-disable func-names */
import forEach from '../../../../javascripts/dom/forEach';

const interestNavigation = document.querySelectorAll('[data-js-module="o-interest-navigation"]');
const interestNavigationSub = document.querySelector('.o-interest-navigation__sub');

function deactivateAllTabs(element) {
  element.querySelectorAll('.o-interest-navigation__main-item').forEach(item => {
    item.classList.remove('active');
    const tabButton = item.querySelector('[role="tab"]');
    tabButton.setAttribute('aria-selected', 'false');
    tabButton.setAttribute('tabindex', '-1');
  });
}

function activateTab(button, parentItem) {
  parentItem.classList.add('active');
  button.setAttribute('aria-selected', 'true');
  button.setAttribute('tabindex', '0');
}

function updateSubNavigation(elementToShow) {
  interestNavigationSub.querySelectorAll('.o-interest-navigation__sub-item').forEach(subitem => {
    subitem.classList.remove('active');
    subitem.setAttribute('hidden', '');

    if (subitem.classList.contains(elementToShow)) {
      subitem.classList.add('active');
      subitem.removeAttribute('hidden');
    }
  });
}

function handleTabClick(button, element) {
  const parentItem = button.closest('.o-interest-navigation__main-item');
  const elementToShow = parentItem.dataset.alement;

  deactivateAllTabs(element);
  activateTab(button, parentItem);
  updateSubNavigation(elementToShow);
}

function handleArrowKeys(e, tabs, currentIndex) {
  e.preventDefault();
  const nextIndex = e.key === 'ArrowRight'
    ? (currentIndex + 1) % tabs.length
    : (currentIndex - 1 + tabs.length) % tabs.length;

  tabs[nextIndex].focus();
  tabs[nextIndex].click();
}

function handleHomeEndKeys(e, tabs) {
  e.preventDefault();
  const targetTab = e.key === 'Home' ? tabs[0] : tabs[tabs.length - 1];
  targetTab.focus();
  targetTab.click();
}

function handleKeyboardNavigation(e) {
  if (!e.target.matches('[role="tab"]')) return;

  const tabs = [...document.querySelectorAll('[role="tab"]')];
  const currentIndex = tabs.indexOf(e.target);

  if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
    handleArrowKeys(e, tabs, currentIndex);
  } else if (e.key === 'Home' || e.key === 'End') {
    handleHomeEndKeys(e, tabs);
  }
}

function initTabClickEvents(element) {
  element.querySelectorAll('[role="tab"]').forEach(button => {
    button.addEventListener('click', () => handleTabClick(button, element));
  });
}

function initKeyboardEvents() {
  document.addEventListener('keydown', handleKeyboardNavigation);
}

export default function init() {
  const initInterestNavigation = async () => {
    forEach(interestNavigation, (index, element) => {
      initTabClickEvents(element);
    });

    initKeyboardEvents();
  };

  if (interestNavigation.length) initInterestNavigation();
}

if (interestNavigation.length) init();